/* eslint-disable no-else-return */
import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  IconButton,
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
  withStyles,
  makeStyles,
  Chip,
  InputBase,
  InputAdornment,
  Select,
  Input,
  Paper,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  MenuItem,
} from '@material-ui/core'
import InputMask from 'react-input-mask'
import { BiCalculator } from 'react-icons/bi'

import { duplicateTime, exportFormatedMoney } from '../../../util/utils'
import NumberFormatCustom from '../../components/NumberFormat'
import colors from '../../../assets/colors'
import Icon from '@mdi/react'
import {
  mdiCalculatorVariant,
  mdiCash,
  mdiCash100,
  mdiCashRefund,
  mdiChevronDown,
  mdiClose,
  mdiDelete,
  mdiMenuDown,
} from '@mdi/js'
import fontSizes from '../../../assets/fontSizes'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import NumberFormat from 'react-number-format'
import InputNumberCustom from '../../../components/hooks/BaseInputNumber'
import { useSelector } from 'react-redux'

const StyledTableCellBody = withStyles(theme => ({
  head: {
    backgroundColor: 'inherit',
    color: colors.textPrimary,
  },
  body: {
    fontSize: 14,
    padding: '4px 12px',
    color: colors.textPrimary,
  },
}))(TableCell)

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: 'inherit',
    color: colors.primary,
    padding: '6px 0px',
    borderColor: colors.secondary,
    textAlign: 'center',
  },
  body: {
    fontWeight: 700,
    fontSize: 14,
  },
}))(TableCell)

const useStyles = makeStyles({
  table: {
    padding: '0 8px',
    borderRadius: '15px',
    backgroundColor: '#D9D9D94D',
  },
  formasPagamentoContainer: {
    margin: '1.5rem 0',
  },
  formasPagamentoBox: {
    padding: '8px 0',
    border: `1px solid`,
    height: '100%',
    borderRadius: '15px',
    borderColor: 'rgba(68, 158, 104, 0.1)',
    backgroundColor: 'rgba(58, 168, 115, 0.1)',
    boxShadow: '5px 5px 20px 0px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    padding: '12px 32px',
  },
  chip: {
    backgroundColor: 'inherit',
    border: `2px solid ${colors.graylight}`,
    fontSize: '14px',
    height: '24px',
  },
  paper: {
    // marginRight: theme.spacing(2),
    borderRadius: '10px',
    color: colors.textPrimary,
    fontSize: fontSizes.text,
    position: 'relative',
    marginTop: '1.7em',
    boxShadow: '0px 0px 7px 0px #00000040',
  },
  buttons: {
    color: colors.primary,
  },
  ref: {
    width: '50px',
    height: '50px',
    position: 'absolute',
    backgroundColor: '#FFFF',
    transform: 'rotate(45deg)',
    top: '4px',
    left: '32%',
    '&:hover': {
      backgroundColor: '#FFFF',
    },
  },
  menuList: {
    padding: '10px',
  },
  menuItem: {
    padding: '6px 12px',
    height: 'auto',
    lineHeight: '1',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
  },
  newPaymentMethod: {
    fontWeight: '700',
    marginTop: '10px',
    whiteSpace: 'pre-wrap',
    lineBreak: 'auto',
    height: 'auto',
    maxWidth: '139px',
    textAlign: 'start',
    fontSize: '14px',
    padding: 0,
    borderRadius: 0,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
  },
})

function TotalTable({
  form,
  setForm,
  noDiscount,
  onChangeFinalValue,
  handleChangeGeneralDiscount,
  handleChangeFinalValue,
  discountAverage = '',
  updateOnlyServiceValue = false,
  handleChangeCashbackApplied = (value = 0) => {},
}) {
  const cashback = useSelector(state => state.client.cashback)

  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  const times = useMemo(() => {
    const { services } = form

    const array = []

    if (!services.length) array.push(duplicateTime([`00:00:00`], 1))

    services?.map(item => {
      if (!item.final_time) return
      if (item.final_time.length == 1) return
      array.push(duplicateTime([`${item.final_time}:00`], 1))
    })

    return array
  }, [form?.services])

  const formatTime = time => {
    const splitedTime = time.split(':')
    return `${splitedTime[0]}:${splitedTime[1]}`
  }

  const availableCashback = Number(form?.cashback_value) || 0
  const appliedCashback = Number(form?.cashback_applied) || 0

  // O aplicado também libera o bloco: na edição os pontos já foram debitados na
  // criação da OS, então o saldo pode ser 0 e ainda existir cashback aplicado.
  const renderCashback = availableCashback > 0 || appliedCashback > 0

  // Recalculado no render (mesma regra do backend: total_with_discount -
  // cashback_applied) para não ficar preso ao valor que veio da API quando o
  // desconto/valor final é alterado na edição.
  const finalValueWithCashback =
    (Number(form?.final_value_discount) || 0) - appliedCashback

  return (
    <>
      <Grid container spacing={4} justifyContent="flex-end">
        <Grid item xs style={{ minWidth: '440px' }}>
          <TableContainer className={classes.table}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <StyledTableCell aling="center">Total Horas</StyledTableCell>
                  <StyledTableCell aling="center">
                    Desconto Geral
                  </StyledTableCell>
                  <StyledTableCell aling="center">
                    Total S/ Desconto
                  </StyledTableCell>

                  <StyledTableCell aling="center">
                    Total C/ Desconto
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <StyledTableCellBody align="center">
                    {formatTime(duplicateTime(times, 1))}
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    <TextField
                      value={discountAverage || form.general_discount}
                      onChange={handleChangeGeneralDiscount}
                      placeholder="0%"
                      InputProps={{
                        inputComponent: InputNumberCustom,
                        inputProps: {
                          suffix: ' %',
                          allowNegative: false,
                          style: { textAlign: 'center', maxWidth: '100px' },
                        },
                      }}
                    />
                  </StyledTableCellBody>
                  <StyledTableCellBody align="center">
                    {exportFormatedMoney(noDiscount || 0)}
                  </StyledTableCellBody>

                  <StyledTableCellBody align="center">
                    <Box
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                      }}
                    >
                      <TextField
                        placeholder="Valor Final"
                        value={form.final_value_discount}
                        onBlur={onChangeFinalValue}
                        onChange={handleChangeFinalValue}
                        InputProps={{
                          inputComponent: InputNumberCustom,
                          inputProps: {
                            prefix: 'R$ ',
                            style: {
                              textAlign: 'center',
                              color: colors.textPrimary,
                            },
                          },
                        }}
                      />
                      <IconButton
                        color="inherit"
                        onClick={onChangeFinalValue}
                        aria-label="Close"
                      >
                        <Icon
                          path={mdiCalculatorVariant}
                          size={1}
                          title="Calcular desconto"
                        />
                      </IconButton>
                    </Box>
                  </StyledTableCellBody>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

        {renderCashback && (
          <Grid item>
            <Box
              style={{
                width: '400px',
                backgroundColor: colors.lightGray,
                padding: '.4em 1em',
                height: '100%',
                borderRadius: 15,
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography
                        style={{
                          fontWeight: 'bold',
                          color: colors.primary,
                        }}
                        as="h4"
                      >
                        Cashback Disponível:
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        style={{
                          color: colors.textPrimary,
                        }}
                        as="h4"
                      >
                        {exportFormatedMoney(availableCashback)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography
                        style={{
                          fontWeight: 'bold',
                          color: colors.primary,
                        }}
                        as="h4"
                      >
                        Cashback Aplicado:
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Box
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: 4,
                        }}
                      >
                        <TextField
                          placeholder="Cashback"
                          value={form.cashback_applied}
                          onChange={e => {
                            const { value } = e
                            handleChangeCashbackApplied(parseFloat(value))
                          }}
                          InputProps={{
                            inputComponent: InputNumberCustom,
                            inputProps: {
                              prefix: 'R$ ',
                              style: {
                                padding: 0,
                                width: '160px',
                                textAlign: 'center',
                                color: colors.textPrimary,
                              },
                            },
                          }}
                        />
                        {/* <IconButton
                          color="inherit"
                          onClick={onChangeFinalValue}
                          aria-label="Close"
                          style={{ padding: 0, color: colors.textGray }}
                        >
                          <Icon
                            path={mdiCalculatorVariant}
                            size={1}
                            title="Calcular desconto"
                          />
                        </IconButton> */}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <Typography
                        style={{
                          fontWeight: 'bold',
                          color: colors.primary,
                        }}
                        as="h4"
                      >
                        Total C/ Desconto + Cashback:
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        style={{
                          color: colors.textPrimary,
                        }}
                        as="h4"
                      >
                        {exportFormatedMoney(finalValueWithCashback)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        )}
      </Grid>

      {form.payment_options && (
        <Box component="div" className={classes.formasPagamentoContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography style={{ color: colors.textGray }}>
                    Observações da OS
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <InputBase
                    value={form.general_service_observations}
                    onChange={e =>
                      setForm({
                        ...form,
                        general_service_observations: e.target.value,
                      })
                    }
                    multiline
                    inputProps={{
                      style: {
                        minHeight: '95px',
                        height: '95%',
                      },
                    }}
                    fullWidth
                    style={{
                      borderRadius: '15px',
                      border: `1px solid ${colors.graylight}`,
                      color: colors.textGray,
                      padding: '8px',
                      minHeight: '115px',
                      height: '100%',
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    style={{ color: colors.textGray, fontSize: '12px' }}
                  >
                    *Observações da OS não aparecem no APP do técnico!
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography style={{ color: colors.textGray }}>
                    Observações para o Técnico
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <InputBase
                    value={form.general_observations}
                    onChange={e =>
                      setForm({
                        ...form,
                        general_observations: e.target.value,
                      })
                    }
                    multiline
                    inputProps={{
                      style: {
                        minHeight: '95px',
                        height: '95%',
                      },
                    }}
                    fullWidth
                    style={{
                      borderRadius: '15px',
                      border: `1px solid ${colors.graylight}`,
                      color: colors.textGray,
                      padding: '8px',
                      minHeight: '115px',
                      height: '100%',
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography
                    style={{ color: colors.textGray, minHeight: '21px' }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box
                    className={classes.formasPagamentoBox}
                    style={{
                      minHeight: '116px',
                    }}
                  >
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="flex-start"
                      style={{
                        paddingBottom: '12px',
                        borderBottom: `2px solid ${colors.graylight}`,
                      }}
                    >
                      <Grid item xs={4} style={{ color: colors.textGray }}>
                        <Typography>Formas de pagamento:</Typography>
                      </Grid>

                      <Grid item xs={8}>
                        <Box
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            width: '100%',
                          }}
                        >
                          <Box
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              flex: '1',
                              gap: '4px',
                            }}
                          >
                            {form?.payment_options
                              ?.filter(o => o.checked)
                              ?.map(item => {
                                if (item?.checked) {
                                  return (
                                    <Chip
                                      style={{
                                        color: colors.textGray,
                                        fontSize: '12px',
                                      }}
                                      avatar={
                                        <Icon
                                          style={{
                                            cursor: 'pointer',
                                          }}
                                          path={mdiClose}
                                          size={0.6}
                                          onClick={() => {
                                            const newPaymentOptions =
                                              form.payment_options.map(
                                                payment => {
                                                  if (payment.id === item.id) {
                                                    payment.checked =
                                                      !item.checked
                                                  }
                                                  return payment
                                                }
                                              )
                                            setForm({
                                              ...form,
                                              payment_options:
                                                newPaymentOptions,
                                            })
                                          }}
                                        />
                                      }
                                      label={item?.value}
                                      className={classes.chip}
                                    />
                                  )
                                }
                              })}
                          </Box>
                          <IconButton
                            ref={anchorRef}
                            aria-controls={open ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={handleToggle}
                            disabled={updateOnlyServiceValue}
                          >
                            <Icon path={mdiMenuDown} size={0.8} />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    style={{ color: colors.textGray, minHeight: '18px' }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Grid container spacing={1}>
                {/* <Grid item xs={12}>
                  <Typography
                    style={{ color: colors.textGray, minHeight: '21px' }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box className={classes.formasPagamentoBox}>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="flex-start"
                      style={{
                        paddingBottom: '12px',
                        borderBottom: `2px solid ${colors.graylight}`,
                      }}
                    >
                      <Grid item xs={4} style={{ color: colors.textGray }}>
                        <Typography>Formas de pagamento:</Typography>
                      </Grid>

                      <Grid item xs={8}>
                        <Box
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            width: '100%',
                          }}
                        >
                          <Box
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              flex: '1',
                              gap: '4px',
                            }}
                          >
                            {form?.payment_options
                              ?.filter(o => o.checked)
                              ?.map(item => {
                                if (item?.checked) {
                                  return (
                                    <Chip
                                      style={{
                                        color: colors.textGray,
                                        fontSize: '12px',
                                      }}
                                      avatar={
                                        <Icon
                                          style={{
                                            cursor: 'pointer',
                                          }}
                                          path={mdiClose}
                                          size={0.6}
                                          onClick={() => {
                                            const newPaymentOptions =
                                              form.payment_options.map(
                                                payment => {
                                                  if (payment.id === item.id) {
                                                    payment.checked =
                                                      !item.checked
                                                  }
                                                  return payment
                                                }
                                              )
                                            setForm({
                                              ...form,
                                              payment_options:
                                                newPaymentOptions,
                                            })
                                          }}
                                        />
                                      }
                                      label={item?.value}
                                      className={classes.chip}
                                    />
                                  )
                                }
                              })}
                          </Box>
                          <IconButton
                            ref={anchorRef}
                            aria-controls={open ? 'menu-list-grow' : undefined}
                            aria-haspopup="true"
                            onClick={handleToggle}
                            disabled={updateOnlyServiceValue}
                          >
                            <Icon path={mdiMenuDown} size={0.8} />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    style={{ color: colors.textGray, minHeight: '21px' }}
                  />
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>

          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            style={{ zIndex: 99 }}
            placement="bottom-end"
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper className={classes.paper}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                      className={classes.menuList}
                    >
                      {form?.payment_options?.map(item => {
                        if (!item?.checked) {
                          return (
                            <MenuItem
                              onClick={() => {
                                const newPaymentOptions =
                                  form.payment_options.map(payment => {
                                    if (payment.id === item.id) {
                                      payment.checked = !item.checked
                                    }
                                    return payment
                                  })
                                setForm({
                                  ...form,
                                  payment_options: newPaymentOptions,
                                })
                              }}
                              className={classes.menuItem}
                            >
                              {item?.value}
                            </MenuItem>
                          )
                        }
                      })}

                      <MenuItem className={classes.menuItem}>
                        <IconButton
                          component={Link}
                          className={classes.newPaymentMethod}
                          to="/payment-method"
                        >
                          Cadastrar nova forma de pagamento
                        </IconButton>
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      )}
    </>
  )
}

export default TotalTable
